import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { postResendEmailVerification } from '@arrived/api_v2';
import { ApiError, EmailVerificationResendResponse, UserId } from '@arrived/models';

export function useResendEmailVerificationMutation(
  options?: UseMutationOptions<EmailVerificationResendResponse, ApiError, UserId>
) {
  return useMutation((userId) => postResendEmailVerification(userId), {
    ...options,
  });
}
